import { getAI, getGenerativeModel, GoogleAIBackend, type GenerativeModel } from 'firebase/ai';
import app from '@/services/firebase/config';

// firebase/ai への依存をこのファイルに集約するため、利用側が使う型を再エクスポートする
export type { GenerativeModel };

/**
 * Geminiモデルの生成設定
 */
export interface GeminiModelParams {
  /** 使用するモデル名 */
  model: string;
  /** 最大出力トークン数 */
  maxOutputTokens: number;
  /** 温度パラメータ（0-1） */
  temperature: number;
}

/**
 * Firebase AI Logic の AI インスタンス（遅延初期化・シングルトン）
 */
let aiInstance: ReturnType<typeof getAI> | null = null;

/**
 * Firebase AI Logic の AI インスタンスを取得する
 *
 * APIキーをクライアントコードに保持せず、Firebaseアプリの認証情報を通じて
 * Gemini を呼び出す。これによりビルド成果物に秘密情報が埋め込まれない。
 */
function getAIInstance(): ReturnType<typeof getAI> {
  if (!aiInstance) {
    aiInstance = getAI(app, { backend: new GoogleAIBackend() });
  }
  return aiInstance;
}

/**
 * 指定された設定で Gemini の生成モデルを取得する
 *
 * @param params モデル設定
 * @returns Firebase AI Logic 経由の生成モデル
 */
export function getGeminiModel(params: GeminiModelParams): GenerativeModel {
  return getGenerativeModel(getAIInstance(), {
    model: params.model,
    generationConfig: {
      maxOutputTokens: params.maxOutputTokens,
      temperature: params.temperature,
    },
  });
}
